module.exports = __webpack_public_path__ + "static/media/settings.ee7c8f12.svg";